var baseURL = "/admin";
var playlists = baseURL + "/playlists";
var tracks = baseURL + "/tracks";
var users = baseURL + "/users";
var clients = users + "/clients";
var musicArchives = baseURL + "/music-archives";
var playlistsBusinessTypes = baseURL + "/playlists-business-types";
var genres = baseURL + "/genres";
var logs = baseURL + "/logs";
var settings = baseURL + "/settings";
export var admin = {
    home: function () { return clients; },
    playlists: {
        index: function () { return playlists; },
        edit: function (id) { return playlists + "/" + id + "/edit"; },
    },
    musicArchives: {
        index: function () { return musicArchives; },
        edit: function (id) { return musicArchives + "/" + id + "/edit"; },
    },
    tracks: {
        index: function () { return tracks; },
        edit: function (id) { return tracks + "/" + id + "/edit"; },
        upload: function () { return tracks + "/upload"; },
    },
    clients: {
        index: function () { return clients; },
        view: function (id) { return clients + "/" + id; },
    },
    playlistsBusinessTypes: {
        viewAny: function () { return playlistsBusinessTypes; },
    },
    genres: {
        index: function () { return genres; },
    },
    logs: {
        index: function () { return logs; },
    },
    settings: {
        index: function () { return settings; },
    },
};
